import React, { useState } from "react";
import "./EnquiryForm.css";

function EnquiryForm() {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    preferredDate: "",
    treatment: "",
    message: "",
  });

  const [status, setStatus] = useState({
    loading: false,
    success: false,
    error: false,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ loading: true, success: false, error: false });

    try {
      // Sends form submission data directly to your email endpoint
      const response = await fetch("https://formspree.io/f/mljgrzgq", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setStatus({ loading: false, success: true, error: false });
        // Reset form input fields upon successful submission
        setFormData({
          name: "",
          phone: "",
          email: "",
          preferredDate: "",
          treatment: "",
          message: "",
        });
      } else {
        setStatus({ loading: false, success: false, error: true });
      }
    } catch (err) {
      setStatus({ loading: false, success: false, error: true });
    }
  };

  return (
    <section className="enquiry-section">
      <div className="enquiry-container">
        
        {/* Left Content Area */}
        <div className="enquiry-info">
          <p className="sub-title">— ENQUIRE & BOOK</p>
          <h2 className="main-title">
            Ready to <br />
            begin your <br />
            <span>treatment journey?</span>
          </h2>

          <p className="description">
            Tell us a little about what you'd like to achieve and we'll be in
            touch to arrange your free, no-obligation consultation. New clients
            receive 10% off their first treatment.
          </p>

          <div className="divider" />

          <p className="quicker-reply-text">Prefer a quicker reply?</p>

          <div className="action-buttons">
            <a
              href="https://wa.me/447802484141"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-whatsapp"
            >
              <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor">
                <path d="M12.031 2c-5.517 0-9.997 4.48-9.997 9.998 0 2.146.68 4.133 1.839 5.757L2 22l4.417-1.157a9.96 9.96 0 005.614 1.708c5.518 0 9.998-4.48 9.998-9.998A9.997 9.997 0 0012.031 2zm0 18.232c-1.802 0-3.504-.486-4.978-1.332l-.358-.207-2.628.688.7-2.562-.229-.365a8.214 8.214 0 01-1.282-4.456c0-4.555 3.706-8.261 8.261-8.261 4.556 0 8.262 3.706 8.262 8.261 0 4.556-3.706 8.262-8.262 8.262z" />
              </svg>
              CHAT ON WHATSAPP
            </a>

            <a href="tel:07802484141" className="btn btn-call">
              CALL 07802 484141
            </a>
          </div>
        </div>

        {/* Right Form Container */}
        <div className="enquiry-form-card">
          <form onSubmit={handleSubmit}>
            <div className="form-grid">
              
              {/* Name */}
              <div className="form-group">
                <label>NAME</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>

              {/* Phone */}
              <div className="form-group">
                <label>PHONE</label>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                />
              </div>

              {/* Email */}
              <div className="form-group">
                <label>EMAIL</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>

              {/* Preferred Date */}
              <div className="form-group">
                <label>PREFERRED DATE <span className="optional">(optional)</span></label>
                <input
                  type="date"
                  name="preferredDate"
                  value={formData.preferredDate}
                  onChange={handleChange}
                />
              </div>

              {/* Treatment Select */}
              <div className="form-group full-width">
                <label>TREATMENT / SERVICE</label>
                <select
                  name="treatment"
                  value={formData.treatment}
                  onChange={handleChange}
                >
                  <option value="">Select a treatment</option>
                  <option value="HIFU Face & Neck">HIFU Face & Neck</option>
                  <option value="Skin Boosters & Profhilo">Skin Boosters & Profhilo</option>
                  <option value="Microneedling">Microneedling</option>
                  <option value="PRP Hair Restoration">PRP Hair Restoration</option>
                  <option value="Facial Sculpting Massage">Facial Sculpting Massage</option>
                  <option value="Transformation Package">Transformation Package</option>
                  <option value="Bikini Ready Body Package">Bikini Ready Body Package</option>
                  <option value="Hair Restoration Package">Hair Restoration Package</option>
                </select>
              </div>

              {/* Message */}
              <div className="form-group full-width">
                <label>MESSAGE <span className="optional">(optional)</span></label>
                <textarea
                  name="message"
                  rows="4"
                  placeholder="Your goals, questions or anything we should know"
                  value={formData.message}
                  onChange={handleChange}
                />
              </div>

            </div>

            {/* Bottom Form Action */}
            <div className="form-footer">
              <p
                className={`disclaimer ${
                  status.success ? "status-success" : status.error ? "status-error" : ""
                }`}
              >
                {status.success
                  ? "✓ Thank you! Your enquiry has been sent to our email."
                  : status.error
                  ? "✕ Something went wrong. Please try again."
                  : "We only use your details to respond to your enquiry."}
              </p>

              <button
                type="submit"
                className="submit-btn"
                disabled={status.loading}
              >
                {status.loading ? "SENDING..." : "SEND ENQUIRY"}
              </button>
            </div>
          </form>
        </div>

      </div>
    </section>
  );
}

export default EnquiryForm;